import { PERSISTENCE_STATE_KEYS } from "@/other/constants/PersistenceStateKeys";
import { useSwivuStore } from "@/react/hooks/useSwivuStore";
import { KeyValueModel } from "@/bryntum-lib/models/KeyValueModel";
import { STORE_KEYS } from "@/other/constants/StoreKeys";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";

export const useHasCompanyCamKey = (): boolean => {
  const { userPreferences } = useSwivuBryntumContext();

  useSwivuStore<KeyValueModel>({
    storeId: STORE_KEYS.boardPreferencesStore,
    subscriberFn: ({ record }) => record.key === PERSISTENCE_STATE_KEYS.hasCompanyCamApiKey,
  });

  return (
    userPreferences?.getSetting(PERSISTENCE_STATE_KEYS.hasCompanyCamApiKey, "false", true) === "true"
  );
};
